import React from 'react';

import {
  LTButton,
  LTCounterLabel,
  LTLoader,
  LTTestStatusLabel,
  LTTooltip,
} from '@lambdatestincprivate/lt-components';
import { TestStatusMap } from '../../constants/test';
import { getStatusIconAndClassPrefix } from '../../utils/statusOptions';

const StatusChip = ({ status, count, isSelected, onToggle }) => {
  const { statusIconName, statusName } = getStatusIconAndClassPrefix(status);

  return (
    <LTTooltip text={statusName} direction={LTTooltip.Direction.BOTTOM}>
      <LTButton
        aria-label={`Filter by ${statusName} tests`}
        aria-pressed={isSelected}
        data-testid={`sidebar-status-filter-${status}`}
        leadingIcon={
          status !== TestStatusMap.RUNNING && statusIconName ? (
            <span aria-hidden="true">
              <LTTestStatusLabel
                iconSrc={statusIconName}
                status={status}
                showStatusText={false}
                width={16}
                height={16}
              />
            </span>
          ) : undefined
        }
        onClick={onToggle}
        size={LTButton.Size.SMALL}
        sx={{
          backgroundColor: isSelected ? '#ECEFF2' : undefined,
          border: isSelected ? '1px solid rgb(221, 221, 221)' : undefined,
          padding: '6px',
          span: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          },
        }}
        variant={LTButton.Variant.INVISIBLE}
      >
        {status === TestStatusMap.RUNNING && (
          <LTLoader
            containerStyles={{ padding: 0, marginRight: '4px' }}
            size={LTLoader.SpinnerSizes.SMALL}
          />
        )}
        <LTCounterLabel
          count={count}
          scheme={LTCounterLabel.Scheme.SECONDARY}
          addDefaultMargin={false}
        />
      </LTButton>
    </LTTooltip>
  );
};

const StatusFilterChips = ({
  statusCounts,
  selectedStatuses,
  onStatusToggle,
}) => {
  if (!statusCounts || Object.keys(statusCounts).length === 0) {
    return null;
  }

  return (
    <>
      {Object.entries(statusCounts).map(([status, count]) => (
        <StatusChip
          key={status}
          status={status}
          count={count}
          isSelected={(selectedStatuses || []).includes(status)}
          onToggle={() => onStatusToggle?.(status)}
        />
      ))}
    </>
  );
};

export default StatusFilterChips;
